module.exports = __webpack_public_path__ + "staticcomp/img/cover.794ea1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/1/cover.jpg
// module id = 1fjZ
// module chunks = 39